// Import custom CSS
import '../scss/styles.scss';

// Import Bootstrap's JavaScript
import * as bootstrap from 'bootstrap';

// Import custom JavaScript
import './animate';
import './anchor';
import './glide';
import './tocbot';
import './birdy-sm-nav';
import './birdy-burger-btn';
import './gsap';
import './swiper';
import './plyr';

// Bootstrap Javascript
document.addEventListener('DOMContentLoaded', function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
});